
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("j5cB3", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cOrQJ = parcelRequire("cOrQJ");


const $43c705326a57355f$export$c720381daa58fcbb = ()=>{
    const $ = (0, $frIzR.c)(2);
    const adsTheme = (0, $cOrQJ.default)();
    let t0;
    if ($[0] !== adsTheme) {
        t0 = adsTheme;
        $[0] = adsTheme;
        $[1] = t0;
    } else t0 = $[1];
    const effectiveTheme = t0;
    return effectiveTheme?.colorMode === "dark";
};
module.exports["useIsDarkMode"] = $43c705326a57355f$export$c720381daa58fcbb;

});

parcelRegister("c5zvz", function(module, exports) {
$parcel$export(module.exports, "useConfluenceStandardToPremiumPUBTouchpoint", () => (parcelRequire("fBwOr")).useConfluenceStandardToPremiumPUBTouchpoint);
$parcel$export(module.exports, "StandardToPremiumModalMountComponent", () => (parcelRequire("5DQLv")).StandardToPremiumModalMountComponent);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5izcQ = parcelRequire("5izcQ");


var $bedQP = parcelRequire("bedQP");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");



var $fBwOr = parcelRequire("fBwOr");


var $5DQLv = parcelRequire("5DQLv");

const $ce6cbe4a9370c72f$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce6cbe4a9370c72f$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw _1ydi18uv",
            __cmplp.className
        ])
    });
});

const $ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IlAy6",
    name: "EditionAwarenessUpsellLoadable",
    loader: async ()=>(await (parcelRequire("iUYdU"))).EditionAwarenessUpsell
});
const $ce6cbe4a9370c72f$export$f255ec0f3619af65 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(({ navVersion: navVersion })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$RemovedSpotlightTarget, {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable, {
        navVersion: navVersion
    })));
});
module.exports["EditionAwarenessUpsellExperiment"] = $ce6cbe4a9370c72f$export$f255ec0f3619af65;

});

parcelRegister("fBwOr", function(module, exports) {

var $e3pFO = parcelRequire("e3pFO");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");


var $inPa6 = parcelRequire("inPa6");


var $50xoH = parcelRequire("50xoH");


var $7Sm4c = parcelRequire("7Sm4c");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $99oLS = parcelRequire("99oLS");


var $hxSIT = parcelRequire("hxSIT");


var $aT8im = parcelRequire("aT8im");


var $jMyy4 = parcelRequire("jMyy4");

const $000cc169882182f2$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    persistentUpgradeMenuItemFreePlanTitle: {
        id: "experiment-edition-awareness-for-standard-to-premium.section.message.persistent-upgrade.menuitem.premiumplan.title",
        defaultMessage: "Upgrade"
    }
});
const $000cc169882182f2$export$70b32605d3b8db81 = (navVersion)=>{
    const [renderFailed, setRenderFailed] = (0, $42omo.useState)(false);
    const { cloudId: cloudId, isEligibleForUpsellExperiment: isEligibleForUpsellExperiment, hasDismissedButton: hasDismissedButton } = (0, $aT8im.useConfluenceStandardToPremiumExperiment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal, setModalProps: setModalProps } = (0, $99oLS.useConfluenceStandardToPremiumModalActions)();
    // isEligibleForUpsellExperiment checks for experiment enrollment as well
    const meetsBaseEligibility = isEligibleForUpsellExperiment && hasDismissedButton;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $e3pFO.default), {
        interopApolloAggClient: true,
        variables: {
            cloudId: cloudId,
            productKey: 'confluence',
            trialOfferingName: 'Premium'
        },
        skip: !meetsBaseEligibility
    });
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'persistent-upgrade-button-standard-to-premium',
                source: 'useConfluenceStandardToPremiumPUBTouchpoint',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion,
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isEligibleForStandardToPremiumPersistentUpgradeButton = meetsBaseEligibility && !renderFailed;
    const experienceUrl = data?.tenantContexts?.[0]?.entitlementInfo?.paidEntitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    if (!loading && isEligibleForStandardToPremiumPersistentUpgradeButton && (!experienceUrl || experienceUrl?.includes('admin/billing'))) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'error',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessStandardToPremiumDialog',
            attributes: {
                product: 'confluence',
                touchpointIntent: 'startTrial',
                dialogId: 'standard-to-premium',
                dialogType: 'modal',
                error: 'No change offering URL found for premium upgrade - using fallback',
                navVersion: navVersion,
                changeOfferingUrl: experienceUrl ?? '',
                isEligibleForStandardToPremiumPersistentUpgradeButton: isEligibleForStandardToPremiumPersistentUpgradeButton
            },
            source: 'useConfluenceStandardToPremiumPUBTouchpoint'
        }
    }).fire();
    // remove the edition from the change plan urls so they land on the plan selection page for hams || ccp
    // there may be a key in shared tenant context api that can be used instead of this
    const learnMoreUrl = (0, $hxSIT.useBuildLearnMoreLink)(experienceUrl);
    const handlePUBClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'persistent-upgrade-button-standard-to-premium',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion
                },
                source: 'useConfluenceStandardToPremiumPUBTouchpoint'
            }
        }).fire();
        setModalProps({
            experienceUrl: experienceUrl ?? '',
            learnMoreUrl: learnMoreUrl,
            navVersion: navVersion
        });
        showModal({
            touchpointId: 'edition-awareness-standard-to-premium-pub'
        });
    }, [
        createAnalyticsEvent,
        showModal,
        setModalProps,
        experienceUrl,
        learnMoreUrl,
        navVersion
    ]);
    if (!isEligibleForStandardToPremiumPersistentUpgradeButton || loading || error) return [];
    return [
        {
            heading: {
                ...$000cc169882182f2$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanTitle
            },
            items: [
                {
                    action: ()=>handlePUBClick(),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
                        onError: ()=>setRenderFailed(true)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $50xoH.EditionAwarenessStandardPubTouchpoint), {
                        product: "confluence",
                        testId: "edition-awareness-standard-pub-touchpoint",
                        navVersion: navVersion
                    })),
                    key: 'try-premium-plan'
                }
            ]
        }
    ];
};
module.exports["useConfluenceStandardToPremiumPUBTouchpoint"] = $000cc169882182f2$export$70b32605d3b8db81;

});

parcelRegister("e3pFO", function(module, exports) {
/**
 * @generated SignedSource<<014c3d493a2fde51e0a6fa4f09bc8c29>>
 * @relayHash be3ae060e2f957b2adfb254e6120448a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54149d8226391da92fe5e768c4f208171509220a72b1dc7c3344710a49c8b746
const $99718f6709017e62$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "trialOfferingName"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "inTrialOrPreDunning": false
            }
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "trialOfferingName"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "paidEntitlement",
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "alias": "paidEntitlement",
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "be3ae060e2f957b2adfb254e6120448a",
            "id": "54149d8226391da92fe5e768c4f208171509220a72b1dc7c3344710a49c8b746",
            "metadata": {},
            "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
            "operationKind": "query",
            "text": "query useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery($cloudId:ID!,$productKey:String!,$trialOfferingName:String!){tenantContexts(cloudIds:[$cloudId])@optIn(to:[\"CcpAllUserUpgradeAndPay\",\"HamsAllUserUpgradeAndPay\"]){entitlementInfo(hamsProductKey:$productKey){__typename,paidEntitlement:entitlement(where:{inTrialOrPreDunning:false}){__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$trialOfferingName){__typename,experienceUrl}},id}}}}"
        }
    };
}();
$99718f6709017e62$var$node.hash = "8dd9df30188856b8fcd47f1be57af4fa";
var $99718f6709017e62$export$2e2bcd8739ae039 = $99718f6709017e62$var$node;
module.exports["default"] = $99718f6709017e62$export$2e2bcd8739ae039;

});

parcelRegister("50xoH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $inPa6 = parcelRequire("inPa6");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $343be00b8c32c969$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label",
        defaultMessage: "Try the Premium plan"
    },
    persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge",
        defaultMessage: "FREE 30-DAY TRIAL"
    }
});
const $343be00b8c32c969$var$menuItemContentStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexWrap: 'nowrap'
});
const $343be00b8c32c969$var$lozengeContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100'
});
function $343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl({ product: product, testId: testId, navVersion: navVersion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editionAwarenessStandardToPremiumPUB',
                attributes: {
                    source: 'EditionAwarenessStandardPubTouchpoint',
                    product: product,
                    navVersion: navVersion
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        xcss: $343be00b8c32c969$var$menuItemContentStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                ...$343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $343be00b8c32c969$var$lozengeContainerStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    appearance: (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 'discovery' : 'new',
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                        ...$343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment
                    })
                })
            })
        ]
    });
}
function $343be00b8c32c969$export$bf5f4133d9c358a3(props) {
    const { product: product, navVersion: navVersion } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnError = (0, $42omo.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            source: 'unknownErrorSource',
            attributes: {
                product: product,
                edition: 'standard',
                navVersion: navVersion,
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $l998X.jsx)($343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl, {
            ...props
        })
    });
}
module.exports["EditionAwarenessStandardPubTouchpoint"] = $343be00b8c32c969$export$bf5f4133d9c358a3;

});

parcelRegister("99oLS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9968f6026062a518$var$initialState = {
    isOpen: false,
    learnMoreUrl: '',
    experienceUrl: '',
    navVersion: undefined
};
const $9968f6026062a518$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        },
    setModalProps: ({ learnMoreUrl: learnMoreUrl, experienceUrl: experienceUrl, navVersion: navVersion })=>({ setState: setState })=>{
            setState({
                learnMoreUrl: learnMoreUrl,
                experienceUrl: experienceUrl,
                navVersion: navVersion
            });
        }
};
const $9968f6026062a518$var$store = (0, $1P1Tu.createStore)({
    initialState: $9968f6026062a518$var$initialState,
    actions: $9968f6026062a518$var$actions,
    name: 'editionAwarenessStandardToPremiumModalStore'
});
const $9968f6026062a518$export$d912d1373319011f = (0, $9zUhf.createActionsHook)($9968f6026062a518$var$store);
const $9968f6026062a518$export$cd5aa218e504e6f3 = (0, $9zUhf.createHook)($9968f6026062a518$var$store);
module.exports["useConfluenceStandardToPremiumModalActions"] = $9968f6026062a518$export$d912d1373319011f;
module.exports["useConfluenceStandardToPremiumModal"] = $9968f6026062a518$export$cd5aa218e504e6f3;

});

parcelRegister("hxSIT", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8c4b8f8f76d4beac$export$9bcf733c7567f1c = (baseUrl)=>{
    const FALLBACK_URL = '/admin/billing';
    return (0, $42omo.useMemo)(()=>{
        if (!baseUrl) return FALLBACK_URL;
        try {
            const url = new URL(baseUrl);
            const isHams = url.pathname.includes('change-edition');
            if (isHams) // remove "/<edition>" at the end of the path
            url.pathname = url.pathname.split('/').slice(0, -1).join('/');
            else {
                url.searchParams.delete('offeringName');
                url.searchParams.delete('offeringname');
            }
            return url.toString();
        } catch (err) {
            return FALLBACK_URL;
        }
    }, [
        baseUrl
    ]);
};
module.exports["useBuildLearnMoreLink"] = $8c4b8f8f76d4beac$export$9bcf733c7567f1c;

});

parcelRegister("5DQLv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Xlut2",
    name: "LazyStandardToPremiumModal",
    loader: async ()=>(await (parcelRequire("jER9O"))).StandardToPremiumModal
});
const $cf9f6e6dcd5627ce$export$4b9ed4d06294662c = ()=>{
    if ((0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal, null);
    return null;
};
module.exports["StandardToPremiumModalMountComponent"] = $cf9f6e6dcd5627ce$export$4b9ed4d06294662c;

});

parcelRegister("jER9O", function(module, exports) {

let $e4fafcada719dde2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4fafcada719dde2$var$load("6wr18"),
    $e4fafcada719dde2$var$load("hUapU"),
    $e4fafcada719dde2$var$load("8UKe0"),
    $e4fafcada719dde2$var$load("ffEVr"),
    $e4fafcada719dde2$var$load("lRtGG"),
    $e4fafcada719dde2$var$load("hhss7"),
    $e4fafcada719dde2$var$load("9CRBg")
]).then(()=>parcelRequire('hCU0r'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("iUYdU", function(module, exports) {

let $dc5c2c097ff6e37d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dc5c2c097ff6e37d$var$load("6wr18"),
    $dc5c2c097ff6e37d$var$load("lxvzP"),
    $dc5c2c097ff6e37d$var$load("kFEyO"),
    $dc5c2c097ff6e37d$var$load("eufZR"),
    $dc5c2c097ff6e37d$var$load("eeaKR"),
    $dc5c2c097ff6e37d$var$load("ffEVr"),
    $dc5c2c097ff6e37d$var$load("dRpV3"),
    $dc5c2c097ff6e37d$var$load("hhss7"),
    $dc5c2c097ff6e37d$var$load("jY21r"),
    $dc5c2c097ff6e37d$var$load("7EorR"),
    $dc5c2c097ff6e37d$var$load("lz2pE")
]).then(()=>parcelRequire('7Bwbp'));

});

parcelRegister("9h83k", function(module, exports) {
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $e1ab43712dd90283$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $e1ab43712dd90283$export$103711ef09c6edec(color) {
    if (!$e1ab43712dd90283$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}
module.exports["parseHex"] = $e1ab43712dd90283$export$103711ef09c6edec;

});

parcelRegister("XLQOT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


const $1e0f0aa871cc51c1$var$EditionAwarenessLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "v8ebQ",
    name: "EditionAwarenessLoadable",
    loader: async ()=>(await (parcelRequire("F5g9E"))).EditionAwareness
});
const $1e0f0aa871cc51c1$export$a55b02efe3d62583 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_TRANSMUTERS
})(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e0f0aa871cc51c1$var$EditionAwarenessLoadable, null);
});
module.exports["EditionAwareness"] = $1e0f0aa871cc51c1$export$a55b02efe3d62583;

});

parcelRegister("F5g9E", function(module, exports) {

let $07b7e8e37c07505d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07b7e8e37c07505d$var$load("8Fbef"),
    $07b7e8e37c07505d$var$load("dVJPu"),
    $07b7e8e37c07505d$var$load("ibznz"),
    $07b7e8e37c07505d$var$load("6wr18"),
    $07b7e8e37c07505d$var$load("lxvzP"),
    $07b7e8e37c07505d$var$load("2OWSd"),
    $07b7e8e37c07505d$var$load("kFEyO"),
    $07b7e8e37c07505d$var$load("j4CTh"),
    $07b7e8e37c07505d$var$load("1GCFv"),
    $07b7e8e37c07505d$var$load("eufZR"),
    $07b7e8e37c07505d$var$load("8UKe0"),
    $07b7e8e37c07505d$var$load("eeaKR"),
    $07b7e8e37c07505d$var$load("Wowvf"),
    $07b7e8e37c07505d$var$load("5CaYW"),
    $07b7e8e37c07505d$var$load("ffEVr"),
    $07b7e8e37c07505d$var$load("dRpV3"),
    $07b7e8e37c07505d$var$load("hhss7"),
    $07b7e8e37c07505d$var$load("jY21r"),
    $07b7e8e37c07505d$var$load("7EorR"),
    $07b7e8e37c07505d$var$load("8H6xE")
]).then(()=>parcelRequire('lw7p7'));

});

parcelRegister("8MTIk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $4qrTW = parcelRequire("4qrTW");


var $azufL = parcelRequire("azufL");

const $15fa71be19d9664f$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $4qrTW.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $azufL.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
    }, button);
    return button;
});
module.exports["IconButton"] = $15fa71be19d9664f$export$c25acd513dcc8062;

});

parcelRegister("azufL", function(module, exports) {
const $d9f8522a95eafbc1$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
module.exports["getIconButtonTheme"] = $d9f8522a95eafbc1$export$f32bddcb857301f3;

});

parcelRegister("iGpKB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $cs1vW = parcelRequire("cs1vW");


var $8rl4X = parcelRequire("8rl4X");


var $lBYCH = parcelRequire("lBYCH");

const $87e97a5b9ae3c7ef$var$i18n = (0, $h82at.defineMessages)({
    CreateButtonText: {
        id: "app-navigation.create.button",
        defaultMessage: "Create"
    }
});
const $87e97a5b9ae3c7ef$var$CreateButtonComponent = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { onClick: t1, href: href, intl: intl } = t0;
    const onClick = t1 === undefined ? $87e97a5b9ae3c7ef$var$_temp : t1;
    const { resetStickySearchRef: resetStickySearchRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    let t2;
    if ($[0] !== onClick || $[1] !== resetStickySearchRef) {
        t2 = (e)=>{
            onClick(e);
            resetStickySearchRef?.current?.();
        };
        $[0] = onClick;
        $[1] = resetStickySearchRef;
        $[2] = t2;
    } else t2 = $[2];
    const handleCreateClick = t2;
    let t3;
    if ($[3] !== intl) {
        t3 = intl.formatMessage($87e97a5b9ae3c7ef$var$i18n.CreateButtonText);
        $[3] = intl;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== handleCreateClick || $[6] !== href || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8rl4X.Create), {
            onClick: handleCreateClick,
            href: href,
            text: t3,
            testId: "globalCreate"
        });
        $[5] = handleCreateClick;
        $[6] = href;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $87e97a5b9ae3c7ef$export$6d3c345ce7c38fd9 = (0, $cs1vW.default)($87e97a5b9ae3c7ef$var$CreateButtonComponent);
function $87e97a5b9ae3c7ef$var$_temp() {}
module.exports["CreateButton"] = $87e97a5b9ae3c7ef$export$6d3c345ce7c38fd9;

});

parcelRegister("8rl4X", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $4KS7f = parcelRequire("4KS7f");


var $g5gZt = parcelRequire("g5gZt");


var $3gadb = parcelRequire("3gadb");


var $2yFMK = parcelRequire("2yFMK");


var $4qrTW = parcelRequire("4qrTW");


var $8MTIk = parcelRequire("8MTIk");


var $dmlzj = parcelRequire("dmlzj");

const $b44ec5f1b9f342af$var$wrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-smallscreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${(0, $2yFMK.CREATE_BREAKPOINT) - 1}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-largescreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (min-width: ${0, $2yFMK.CREATE_BREAKPOINT}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $b44ec5f1b9f342af$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: buttonTooltip,
        hideTooltipOnClick: true
    }, children) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
const $b44ec5f1b9f342af$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
    const theme = (0, $4qrTW.useTheme)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $b44ec5f1b9f342af$var$wrapperStyles,
        role: "listitem",
        "data-testid": "create-button-wrapper"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($b44ec5f1b9f342af$var$TooltipSwitch, {
        buttonTooltip: buttonTooltip
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
        id: "createGlobalItem",
        "aria-label": label,
        onClick: onClick,
        href: href,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: (0, $dmlzj.getCreateButtonTheme)(theme),
        testId: testId && `${testId}-button`,
        "data-hide-on-smallscreens": true
    }, text)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8MTIk.IconButton), {
        id: "createGlobalItemIconButton",
        testId: testId && `${testId}-icon-button`,
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            color: "currentColor",
            spacing: "spacious",
            label: text
        }),
        onClick: onClick,
        href: href,
        tooltip: iconButtonTooltip,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $dmlzj.getCreateButtonTheme)(theme),
        "aria-label": text,
        "data-hide-on-largescreens": true
    }));
};
module.exports["Create"] = $b44ec5f1b9f342af$export$8ade6fcbf3a7de5d;

});

parcelRegister("2yFMK", function(module, exports) {
const $ec6571ee54ae36da$export$30fa7cc5f2690a43 = 56;
const $ec6571ee54ae36da$export$4033a111ca79977d = 1280;
const $ec6571ee54ae36da$export$24ec62cee78b7042 = 1130;
const $ec6571ee54ae36da$export$d8bde68ac946124f = '--ds--ans--fbc';
const $ec6571ee54ae36da$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $ec6571ee54ae36da$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $ec6571ee54ae36da$export$d81606c1fc5119bc = '--ds--ans--c';
const $ec6571ee54ae36da$export$65f656ad520ea71 = '--ds--ans--bc';
module.exports["HORIZONTAL_GLOBAL_NAV_HEIGHT"] = $ec6571ee54ae36da$export$30fa7cc5f2690a43;
module.exports["PRODUCT_HOME_BREAKPOINT"] = $ec6571ee54ae36da$export$4033a111ca79977d;
module.exports["CREATE_BREAKPOINT"] = $ec6571ee54ae36da$export$24ec62cee78b7042;

});

parcelRegister("dmlzj", function(module, exports) {
const $1af5cbdb2ea2d43e$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...create.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': create.hover,
                ':focus': create.focus,
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && create.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
module.exports["getCreateButtonTheme"] = $1af5cbdb2ea2d43e$export$256eebed8e934f30;

});

parcelRegister("fwSxy", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $afneb = parcelRequire("afneb");


var $2azjJ = parcelRequire("2azjJ");


var $g0EzZ = parcelRequire("g0EzZ");


var $bWLcG = parcelRequire("bWLcG");


var $cStGJ = parcelRequire("cStGJ");

function $90f37d6779fc16bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $90f37d6779fc16bb$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $90f37d6779fc16bb$export$63e083aca343a6ae = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "eq4kchp13"
})("display:none;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $90f37d6779fc16bb$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $cStGJ.default)('span', {
    target: "eq4kchp12"
})("width:", (0, $2azjJ.grid).multiple(2).px, ";height:", (0, $2azjJ.grid).multiple(2).px, ";position:absolute;top:", (0, $2azjJ.grid).px, ";left:", (0, $2azjJ.grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $g0EzZ.N900})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $g0EzZ.B200)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $90f37d6779fc16bb$export$1da38d078e896a10 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp11"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){right:24px;}");
const $90f37d6779fc16bb$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp10"
})("width:", (0, $2azjJ.grid).multiple(2).px, ";height:", (0, $2azjJ.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $g0EzZ.N70)})`, ";background-color:transparent;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $g0EzZ.N500)})`, ";}&>span>svg{vertical-align:unset;}");
const $90f37d6779fc16bb$export$54c466678ae7c638 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp9"
})("display:none;margin:0 ", (0, $2azjJ.grid).px, ";height:", (0, $2azjJ.grid).multiple(4).px, ";padding-bottom:", (0, $2azjJ.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $90f37d6779fc16bb$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $90f37d6779fc16bb$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp8"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $9K4OG.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $2azjJ.dialogWidth) : (0, $2azjJ.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $90f37d6779fc16bb$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $9K4OG.css)(styles, " @media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $2azjJ.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
const $90f37d6779fc16bb$export$b6261a2c5ea449d = /*#__PURE__*/ (0, $cStGJ.default)("input", {
    target: "eq4kchp7"
})("height:", (0, $2azjJ.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $90f37d6779fc16bb$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $2azjJ.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $2azjJ.grid).multiple(1.5).px} ${(0, $2azjJ.grid).multiple(0.25).px};
            margin: 0 ${(0, $2azjJ.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $bWLcG.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");
const $90f37d6779fc16bb$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $cStGJ.default)((0, $afneb.default), {
    target: "eq4kchp6"
})({
    name: "eivff4",
    styles: "display:none"
});
const $90f37d6779fc16bb$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $cStGJ.default)('input', {
    target: "eq4kchp5"
})("height:", (0, $2azjJ.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $g0EzZ.N100})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $g0EzZ.N200)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $g0EzZ.N900)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $g0EzZ.N100})`}`, ";}@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $90f37d6779fc16bb$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp4"
})("position:relative;height:32px;@media screen and (min-width: 781px){min-width:", (props)=>props.shouldFillContainer ? '100%' : '200px', ";}", (props)=>props.shouldFillContainer ? 'width: 100%;' : '', ";");
const $90f37d6779fc16bb$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $90f37d6779fc16bb$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp2"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $2azjJ.collapsedSearchInputWidth;
}, ";");
const $90f37d6779fc16bb$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $cStGJ.default)('span', {
    target: "eq4kchp1"
})("width:", (0, $2azjJ.grid).multiple(2).px, ";height:", (0, $2azjJ.grid).multiple(2).px, ";position:absolute;top:", (0, $2azjJ.grid).px, ";left:", (0, $2azjJ.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $90f37d6779fc16bb$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $cStGJ.default)('span', {
    target: "eq4kchp0"
})("display:none;padding:", (0, $2azjJ.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:flex;}");
module.exports["MobileSearchIconWrapper"] = $90f37d6779fc16bb$export$63e083aca343a6ae;
module.exports["DesktopSearchIconWrapper"] = $90f37d6779fc16bb$export$9673cb6b61244e6e;
module.exports["InputBoxOverlayRight"] = $90f37d6779fc16bb$export$1da38d078e896a10;
module.exports["ClearIconWrapper"] = $90f37d6779fc16bb$export$ff9b1a25d343474d;
module.exports["ArrowIconWrapper"] = $90f37d6779fc16bb$export$54c466678ae7c638;
module.exports["SearchInputContainer"] = $90f37d6779fc16bb$export$c2b37b18a8b54130;
module.exports["SearchInputField"] = $90f37d6779fc16bb$export$b6261a2c5ea449d;
module.exports["HiddenTooltip"] = $90f37d6779fc16bb$export$ca6fe3402791d08e;
module.exports["SSRsearchInputField"] = $90f37d6779fc16bb$export$6d53dccb772ed720;
module.exports["SSRsearchInputWrapper"] = $90f37d6779fc16bb$export$c47d4a3e1f1297f1;
module.exports["SSRformContainer"] = $90f37d6779fc16bb$export$58ae19ee1fc7be8a;
module.exports["SSRsearchInputContainer"] = $90f37d6779fc16bb$export$b40f2abde293e8e4;
module.exports["SSRdesktopSearchIconWrapper"] = $90f37d6779fc16bb$export$eb4e9f55bbe045df;
module.exports["SSRmobileSearchIconWrapper"] = $90f37d6779fc16bb$export$3f33ed4b273b43d;

});

parcelRegister("iSHbD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jluld = parcelRequire("jluld");


var $g0EzZ = parcelRequire("g0EzZ");

const $e1919834031c61bc$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, primaryColor: primaryColor = `var(--ds-text, ${0, $g0EzZ.N800})`, label: label = '' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });
module.exports["SearchIcon"] = $e1919834031c61bc$export$82eafebb825fc23f;

});

parcelRegister("eSS4z", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lgmus = parcelRequire("lgmus");


var $g0EzZ = parcelRequire("g0EzZ");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $f63156beb535cb85$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $g0EzZ.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $g0EzZ.N200)})`,
            borderColor: `var(--ds-border-input, ${(0, $g0EzZ.N100)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $g0EzZ.N600)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $g0EzZ.B100)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $g0EzZ.N0)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $g0EzZ.N100)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $f63156beb535cb85$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $f63156beb535cb85$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, $f63156beb535cb85$export$e6c62eb05a8288ed.default, searchCSS);
};
const $f63156beb535cb85$var$ctx = /*#__PURE__*/ (0, $42omo.createContext)($f63156beb535cb85$export$e6c62eb05a8288ed.default);
const $f63156beb535cb85$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $f63156beb535cb85$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $l998X.jsx)($f63156beb535cb85$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
const $f63156beb535cb85$export$93d4e7f90805808f = ()=>{
    return (0, $42omo.useContext)($f63156beb535cb85$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $f63156beb535cb85$export$f9bb738f552c610d = $f63156beb535cb85$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $f63156beb535cb85$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};
module.exports["ThemeProvider"] = $f63156beb535cb85$export$d8964aec282183a3;
module.exports["useTheme"] = $f63156beb535cb85$export$93d4e7f90805808f;

});

parcelRegister("5bPOK", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $c6bf0727a21a02b6$export$2ad518e2a6db5d40 = /*#__PURE__*/ function(ExperimentParameterValues) {
    ExperimentParameterValues["CONTROL"] = "quick-find-control";
    ExperimentParameterValues["EXPERIMENT"] = "quick-find-experiment";
    ExperimentParameterValues["NOT_ENROLLED"] = "not-enrolled";
    return ExperimentParameterValues;
}({});
const $c6bf0727a21a02b6$export$b627fae0f53cc74b = 'confluence_frontend_quick_find';
const $c6bf0727a21a02b6$export$a5c820d7542f98bf = ()=>{
    const { isRovoEnabled: isRovoEnabledInTCS } = (0, $bQm3c.useSessionData)();
    // A user sees Quick Find if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    // Opting out overrides all other checks
    if ((0, $9wGTI.fg)('confluence_rovo_search_opt_out')) return [
        false,
        null
    ];
    // A user sees Quick Find if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    if (isRovoEnabledInTCS || (0, $9wGTI.fg)('unified_search_in_confluence')) return [
        true,
        {
            abTestId: $c6bf0727a21a02b6$export$b627fae0f53cc74b,
            controlId: "quick-find-control",
            experimentId: "quick-find-experiment"
        }
    ];
    if ((0, $6mKj3.expVal)('confluence_frontend_quick_find', 'cohort', 'not-enrolled') !== "not-enrolled") // this check ensures that we don't overwrite the /experiment API response for users who are not in the Quick Find experiment
    return [
        // today we are overriding the ab context only for quick find. In future when this becomes the standard we wouldnt need this condition
        (0, $6mKj3.expValEquals)('confluence_frontend_quick_find', 'cohort', 'quick-find-experiment'),
        {
            abTestId: $c6bf0727a21a02b6$export$b627fae0f53cc74b,
            controlId: "quick-find-control",
            experimentId: (0, $6mKj3.expVal)('confluence_frontend_quick_find', 'cohort', 'not-enrolled')
        }
    ];
    return [
        // today we are overriding the ab context only for quick find. In future when this becomes the standard we wouldnt need this condition
        (0, $6mKj3.expValEquals)('confluence_frontend_quick_find', 'cohort', 'quick-find-experiment'),
        null
    ];
};
module.exports["useQuickFindEnabled"] = $c6bf0727a21a02b6$export$a5c820d7542f98bf;

});

parcelRegister("kvBa6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $c0qxy = parcelRequire("c0qxy");


var $dh538 = parcelRequire("dh538");


var $fG2rA = parcelRequire("fG2rA");

var $epS7s = parcelRequire("epS7s");


var $hr2Qv = parcelRequire("hr2Qv");


var $2ok43 = parcelRequire("2ok43");


var $6CCa2 = parcelRequire("6CCa2");


var $6POBq = parcelRequire("6POBq");

if (!window.inputSkeletonState) (0, $fG2rA.resetInputSkeletonState)();
const $816c13ddd7816a37$export$8f0d616c2469c6b6 = ({ onEnter: onEnter, isNav4Enabled: isNav4Enabled, injectValue: injectValue, customPlaceholder: customPlaceholder, inputRef: inputRef })=>{
    const dialogId = (0, $c0qxy.useId)();
    const { formatMessage: formatMessage, locale: locale } = (0, $1cfRh.default)();
    const initialSearchQuery = (0, $2ok43.getInitialQuery)();
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)((0, $fG2rA.getInputSkeletonFocus));
    const [value, setValue] = (0, $42omo.useState)(()=>injectValue ?? initialSearchQuery);
    const ghostTextData = (0, $42omo.useMemo)(()=>(0, $6CCa2.parseGhostTextData)(customPlaceholder, locale), [
        customPlaceholder,
        locale
    ]);
    const onFocus = (e)=>{
        setIsExpanded(true);
        (0, $fG2rA.setInputSkeletonIsFocus)(true);
        const target = e.currentTarget;
        (0, $fG2rA.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $fG2rA.setInputSkeletonIsFocus)(false);
        (0, $fG2rA.setInputSkeletonSelection)(0, 0, 'none');
    };
    const onKeyDown = (e)=>{
        const target = e.currentTarget;
        if (e.key === 'Escape') {
            target.blur();
            onBlur();
        }
    };
    const onChange = (e)=>{
        const newValue = e.currentTarget.value;
        setValue(newValue);
        (0, $fG2rA.setInputSkeletonQuery)(newValue);
        const target = e.currentTarget;
        (0, $fG2rA.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = (e)=>{
        const target = e.currentTarget;
        (0, $fG2rA.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hr2Qv.Textfield), {
        value: value,
        placeholder: (0, $dh538.fg)('quickfind-ghosttext') ? ghostTextData?.text ?? formatMessage((0, $6POBq.messages).placeholder) : formatMessage((0, $6POBq.messages).placeholder),
        dialogId: dialogId,
        quickFindOpen: isExpanded,
        onEnter: onEnter,
        onFocus: onFocus,
        onBlur: onBlur,
        onSelect: onSelect,
        onKeyDown: onKeyDown,
        onChange: onChange,
        isNav4Enabled: isNav4Enabled,
        inputRef: inputRef
    });
};
module.exports["QuickFindSkeleton"] = $816c13ddd7816a37$export$8f0d616c2469c6b6;

});

parcelRegister("fG2rA", function(module, exports) {
const $2e82d749b860510a$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $2e82d749b860510a$export$b8b6c2e7a0664212 = ()=>{
    return $2e82d749b860510a$var$getWindow()?.inputSkeletonState?.query ?? '';
};
const $2e82d749b860510a$export$baa1c819dd4691f3 = (newQuery)=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.query = newQuery;
};
const $2e82d749b860510a$export$38fcbc98be180790 = ()=>{
    return $2e82d749b860510a$var$getWindow()?.inputSkeletonState?.isFocused || false;
};
const $2e82d749b860510a$export$d3c6894b4e9af000 = (newIsFocused)=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.isFocused = newIsFocused;
};
const $2e82d749b860510a$export$a0c71b3bd9ec143c = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    return {
        selectionStart: inputSkeletonState?.selectionStart ?? 0,
        selectionEnd: inputSkeletonState?.selectionEnd ?? 0,
        selectionDirection: inputSkeletonState?.selectionDirection ?? 'none'
    };
};
const $2e82d749b860510a$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.selectionStart = newSelectionStart;
        inputSkeletonState.selectionEnd = newSelectionEnd;
        inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $2e82d749b860510a$export$c89dd2d5d4024c5e = ()=>{
    const safeWindow = $2e82d749b860510a$var$getWindow();
    if (safeWindow) safeWindow.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $2e82d749b860510a$export$166ce39761ad7743 = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.listeners.forEach(([target, event, handler])=>{
            target.removeEventListener(event, handler);
        });
        inputSkeletonState.listeners = [];
    }
};
const $2e82d749b860510a$export$c830bcf42e072a93 = ()=>{
    $2e82d749b860510a$export$166ce39761ad7743();
    delete $2e82d749b860510a$var$getWindow()?.inputSkeletonState;
};
module.exports["getInputSkeletonQuery"] = $2e82d749b860510a$export$b8b6c2e7a0664212;
module.exports["setInputSkeletonQuery"] = $2e82d749b860510a$export$baa1c819dd4691f3;
module.exports["getInputSkeletonFocus"] = $2e82d749b860510a$export$38fcbc98be180790;
module.exports["setInputSkeletonIsFocus"] = $2e82d749b860510a$export$d3c6894b4e9af000;
module.exports["getInputSkeletonSelection"] = $2e82d749b860510a$export$a0c71b3bd9ec143c;
module.exports["setInputSkeletonSelection"] = $2e82d749b860510a$export$e0d745255b135363;
module.exports["resetInputSkeletonState"] = $2e82d749b860510a$export$c89dd2d5d4024c5e;
module.exports["removeInputSkeletonEventListeners"] = $2e82d749b860510a$export$166ce39761ad7743;
module.exports["removeInputSkeletonState"] = $2e82d749b860510a$export$c830bcf42e072a93;

});

parcelRegister("hr2Qv", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1cfRh = parcelRequire("1cfRh");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jluld = parcelRequire("jluld");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $dHnMl = parcelRequire("dHnMl");


var $cqmOv = parcelRequire("cqmOv");

const $b91b1ab10826f40a$var$textFieldBoxBaseStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.300',
    ':focus': {
        height: 'size.400'
    },
    width: '100%',
    paddingRight: 'space.200'
});
const $b91b1ab10826f40a$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $b91b1ab10826f40a$var$textFieldBoxStylesT26Shape = (0, $ecnYn.xcss)({
    borderRadius: 'radius.medium'
});
const $b91b1ab10826f40a$var$textFieldBoxFocusedStyles = (0, $ecnYn.xcss)({
    height: 'size.400',
    border: 'none',
    paddingRight: '0'
});
const $b91b1ab10826f40a$var$textFieldBoxFocusedElevationStyles = (0, $ecnYn.xcss)({
    boxShadow: 'elevation.shadow.overlay'
});
const $b91b1ab10826f40a$var$textFieldInDialogStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.075',
    position: 'relative',
    zIndex: 'layer'
});
const $b91b1ab10826f40a$var$inputStyles = null;
const $b91b1ab10826f40a$var$inputFocusedStyles = null;
const $b91b1ab10826f40a$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    minWidth: 'size.300',
    minHeight: 'size.300',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $b91b1ab10826f40a$var$iconWrapperFocusedStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.200',
    marginInlineEnd: 'space.150',
    minWidth: 'size.200'
});
const $b91b1ab10826f40a$var$clearIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
}); // Nav3 style overrides
// Can be removed once all supported products use Nav4
const $b91b1ab10826f40a$var$nav3StyleOverrides = {
    textFieldBoxStyles: (0, $ecnYn.xcss)({
        borderColor: 'color.border.input',
        backgroundColor: 'color.background.input',
        borderRadius: 'radius.medium',
        width: '200px'
    }),
    textFieldBoxFocusedStyles: (0, $ecnYn.xcss)({
        backgroundColor: 'elevation.surface.overlay',
        borderRadius: 'radius.large',
        width: '780px'
    }),
    iconWrapperStyles: (0, $ecnYn.xcss)({
        minWidth: '30px'
    }),
    inputStyles: null
};
const $b91b1ab10826f40a$export$d66ddc2063fc70a7 = ({ value: value, dialogId: dialogId, quickFindOpen: quickFindOpen, isNav4Enabled: isNav4Enabled, onEnter: onEnter, onFocus: onFocus, onBlur: onBlur, onSelect: onSelect, onKeyDown: onKeyDown, onChange: onChange, onClear: onClear, inputRef: inputRef, clearIconRef: clearIconRef, placeholder: placeholder, intentRouterEnabled: intentRouterEnabled })=>{
    const intl = (0, $1cfRh.default)();
    const handleKeyDown = (e)=>{
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
        if (typeof onKeyDown === 'function') onKeyDown(e);
    };
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $b91b1ab10826f40a$var$textFieldBoxBaseStyles,
            (!intentRouterEnabled || !quickFindOpen) && $b91b1ab10826f40a$var$textFieldBoxStyles,
            intentRouterEnabled && quickFindOpen && $b91b1ab10826f40a$var$textFieldInDialogStyles,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $b91b1ab10826f40a$var$textFieldBoxStylesT26Shape,
            quickFindOpen ? $b91b1ab10826f40a$var$textFieldBoxFocusedStyles : false,
            !intentRouterEnabled && quickFindOpen && $b91b1ab10826f40a$var$textFieldBoxFocusedElevationStyles,
            !isNav4Enabled && $b91b1ab10826f40a$var$nav3StyleOverrides.textFieldBoxStyles,
            !isNav4Enabled && quickFindOpen && $b91b1ab10826f40a$var$nav3StyleOverrides.textFieldBoxFocusedStyles
        ],
        onClick: ()=>{
            inputRef?.current?.focus();
        },
        testId: "search-input-container",
        role: "search",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $b91b1ab10826f40a$var$iconWrapperStyles,
                    quickFindOpen && $b91b1ab10826f40a$var$iconWrapperFocusedStyles,
                    !isNav4Enabled && $b91b1ab10826f40a$var$nav3StyleOverrides.iconWrapperStyles
                ],
                children: isNav4Enabled || quickFindOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    color: "currentColor",
                    label: "",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $dHnMl.LegacySearchIcon), {
                    isExpanded: !!quickFindOpen
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ref: inputRef,
                onFocus: onFocus,
                onBlur: onBlur,
                onSelect: onSelect,
                onKeyDown: handleKeyDown,
                placeholder: placeholder || intl.formatMessage((0, $cqmOv.messages).inputPlaceholder),
                onChange: onChange,
                value: value,
                "data-testid": "search-input",
                autoComplete: "off",
                "aria-label": intl.formatMessage((0, $cqmOv.messages).inputAriaLabel),
                "aria-expanded": quickFindOpen,
                "aria-controls": quickFindOpen ? dialogId : undefined,
                "aria-haspopup": "true",
                role: "combobox",
                className: (0, $gMc0m.default)([
                    "_12ji1r31 _1qu2glyw _12y31o36 _11q7glyw _11c8fhey _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _syaz1rpy _1bsb1osq _1bto1l2s _o5721q9c _1idr1rpy",
                    quickFindOpen && "_syazi7uo",
                    !isNav4Enabled && "_11c8fhey"
                ])
            }),
            quickFindOpen && value && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $b91b1ab10826f40a$var$clearIconStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ref: clearIconRef,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)",
                            label: ""
                        }),
                    spacing: 'compact',
                    onClick: onClear,
                    label: intl.formatMessage((0, $cqmOv.messages).clearIconLabel),
                    appearance: "subtle",
                    testId: "search-input-clear-button"
                })
            })
        ]
    }));
};
module.exports["Textfield"] = $b91b1ab10826f40a$export$d66ddc2063fc70a7;

});

parcelRegister("dHnMl", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jluld = parcelRequire("jluld");


var $g0EzZ = parcelRequire("g0EzZ");

const $ede29c1f5665b53e$export$c3bd67ecc5ebe519 = ({ isExpanded: isExpanded, primaryColor: primaryColor = `var(--ds-text, ${0, $g0EzZ.N800})`, defaultColor: defaultColor = `var(--ds-text-subtlest, ${0, $g0EzZ.N200})`, label: label = '' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : defaultColor
    });
module.exports["LegacySearchIcon"] = $ede29c1f5665b53e$export$c3bd67ecc5ebe519;

});

parcelRegister("cqmOv", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $3af5468bd2294d58$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    clearIconLabel: {
        id: "input_clear_icon_label",
        defaultMessage: "Clear search"
    },
    inputPlaceholder: {
        id: "input_placeholder",
        defaultMessage: "Search"
    },
    inputAriaLabel: {
        id: "input_aria_label",
        defaultMessage: "Search, press enter to navigate to advanced search with your text query"
    }
});
module.exports["messages"] = $3af5468bd2294d58$export$defe85febe8b728c;

});

parcelRegister("2ok43", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $fG2rA = parcelRequire("fG2rA");

// The query is stored in module scope to persist across remounts
let $e39928e964cca707$var$initialQueryValue;
const $e39928e964cca707$export$ed7270bd966434af = (searchQueryParams)=>{
    const stickySearch = $e39928e964cca707$var$initialQueryValue;
    return (0, $c6GJD.default).initializeCalled() && (0, $c6GJD.default).getExperimentValue('platform_set_initial_search_query_state', 'isEnabled', false) && searchQueryParams || stickySearch || (0, $fG2rA.getInputSkeletonQuery)() || '';
};
const $e39928e964cca707$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $42omo.useEffect)(()=>{
        const skeletonFocused = (0, $fG2rA.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $fG2rA.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $42omo.useEffect)(()=>{
        // Update the module-scoped variable to make it available for remounts
        $e39928e964cca707$var$initialQueryValue = localQuery;
    }, [
        localQuery
    ]);
};
module.exports["getInitialQuery"] = $e39928e964cca707$export$ed7270bd966434af;
module.exports["useInputSkeleton"] = $e39928e964cca707$export$67de3a75cbe82e14;

});

parcelRegister("6CCa2", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");


var $dh538 = parcelRequire("dh538");


var $dS0qJ = parcelRequire("dS0qJ");

var $7f54826d8f69d9e8$export$6891b88a23696d = /*#__PURE__*/ function(GhostTextExperimentCohort) {
    GhostTextExperimentCohort["CONTROL"] = "control";
    GhostTextExperimentCohort["THREE_P"] = "3p";
    return GhostTextExperimentCohort;
}({});
const $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9 = 3;
const $7f54826d8f69d9e8$export$4d19f25c7b83dd4a = (0, $gLLcz.z).object({
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$9bcc9fe305679f00 = (0, $gLLcz.z).object({
    /** Unique key identifying the current ghost text set */ id: (0, $gLLcz.z).string(),
    /** Locale of the ghost text */ locale: (0, $gLLcz.z).string(),
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$b18cd5530389e27a = (data)=>{
    try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(data);
        return result.success;
    } catch  {
        return false;
    }
};
const $7f54826d8f69d9e8$export$bd8829925eef3cc2 = (customPlaceholder, locale)=>{
    if (!(0, $dh538.fg)('quickfind-ghosttext')) return undefined;
    if (!customPlaceholder) return undefined;
    if (!(0, $dS0qJ.isEnglishLocale)(locale) && !(0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) return undefined;
    if ((0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
    try {
        const result = $7f54826d8f69d9e8$export$4d19f25c7b83dd4a.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
};
module.exports["GhostTextExperimentCohort"] = $7f54826d8f69d9e8$export$6891b88a23696d;
module.exports["ROTATION_THRESHOLD"] = $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9;
module.exports["isGhostTextDataV2"] = $7f54826d8f69d9e8$export$b18cd5530389e27a;
module.exports["parseGhostTextData"] = $7f54826d8f69d9e8$export$bd8829925eef3cc2;

});

parcelRegister("dS0qJ", function(module, exports) {
const $c4d36ce3018afd80$export$3ea53827ed349b2e = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return locale.toLowerCase().startsWith('en');
};
module.exports["isEnglishLocale"] = $c4d36ce3018afd80$export$3ea53827ed349b2e;

});

parcelRegister("6POBq", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $8b0984932526998a$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    placeholder: {
        id: "search_dialog_aria_label",
        defaultMessage: "Search"
    }
});
module.exports["messages"] = $8b0984932526998a$export$defe85febe8b728c;

});

parcelRegister("blg7q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $af81f9ffe316c2e0$export$69cf3fc83b854da4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4AEfs",
    name: "ConversationAssistantNavBarButton",
    loader: async ()=>(await (parcelRequire("gQNgI"))).ConversationAssistantNavBarButton
});
module.exports["ConversationAssistantNavBarButton"] = $af81f9ffe316c2e0$export$69cf3fc83b854da4;

});

parcelRegister("gQNgI", function(module, exports) {

let $c447b86073d87b67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c447b86073d87b67$var$load("l4BR3"),
    $c447b86073d87b67$var$load("dtASV"),
    $c447b86073d87b67$var$load("cLqmj"),
    $c447b86073d87b67$var$load("kFEyO"),
    $c447b86073d87b67$var$load("jbxHq"),
    $c447b86073d87b67$var$load("3Zfzp"),
    $c447b86073d87b67$var$load("hhss7"),
    $c447b86073d87b67$var$load("gM13h")
]).then(()=>parcelRequire('1RPPn'));

});

parcelRegister("ih4dR", function(module, exports) {

var $1To4a = parcelRequire("1To4a");


var $5kLSq = parcelRequire("5kLSq");


var $fZitC = parcelRequire("fZitC");


var $6mKj3 = parcelRequire("6mKj3");

const $1b7b278c93e24711$var$NULL_THEME_RESULT = {
    backgroundColor: null,
    highlightColor: null
};
const $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES = [
    '0052CC',
    // ADG3,
    '0C66E4' // ADG4
];
const $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX = 35;
const $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e = ({ backgroundColorRaw: backgroundColorRaw, highlightColorRaw: highlightColorRaw, isDarkMode: isDarkMode })=>{
    if (!backgroundColorRaw || !highlightColorRaw) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    const backgroundColor = $1b7b278c93e24711$var$parseColor(backgroundColorRaw);
    const highlightColor = $1b7b278c93e24711$var$parseColor(highlightColorRaw);
    if ($1b7b278c93e24711$var$isDefaultTheme(backgroundColor, highlightColor)) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    return {
        backgroundColor: isDarkMode && backgroundColor ? $1b7b278c93e24711$var$applyDarkModeTransformation(backgroundColor) : backgroundColor,
        highlightColor: highlightColor
    };
};
/**
 * Determines if the given colors match the default theme.
 */ const $1b7b278c93e24711$var$isDefaultTheme = (backgroundColor, highlightColor)=>{
    if (!backgroundColor || !highlightColor) return false;
    const currentDefaultBackground = $1b7b278c93e24711$var$parseColor((0, $1To4a.default)('elevation.surface', '#ffffff'));
    const isDefaultBackground = $1b7b278c93e24711$var$areColorsEqual(backgroundColor, currentDefaultBackground);
    const highlightColorCodes = (0, $6mKj3.expVal)('confluence_frontend_fix_topnav_styling_hydration', 'isEnabled', false) ? [
        ...$1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES,
        '1868DB'
    ] : $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES;
    const isDefaultHighlight = highlightColorCodes.some((color)=>{
        const currentDefaultColor = $1b7b278c93e24711$var$parseColor((0, $1To4a.default)('color.text.brand', `#${color}`));
        return $1b7b278c93e24711$var$areColorsEqual(highlightColor, currentDefaultColor);
    });
    return isDefaultBackground && isDefaultHighlight;
};
/**
 * Parses and validates a color string using platform utilities.
 * Returns RGB object or null if invalid.
 */ const $1b7b278c93e24711$var$parseColor = (colorToParse)=>{
    if (colorToParse.startsWith('rgba(') && colorToParse.split(',').length === 4) colorToParse = `rgb(${colorToParse.substring(5, colorToParse.lastIndexOf(','))})`;
    else if (colorToParse.startsWith('var(')) colorToParse = $1b7b278c93e24711$var$getCSSVariableValue(colorToParse); // Will only get re-calculated if the variable is from ADS
    return (0, $5kLSq.parseUserColor)(colorToParse);
};
/**
 * Transforms a background color for dark mode by either using the dark surface token
 * or reducing lightness for custom colors.
 */ const $1b7b278c93e24711$var$getDarkModeBackgroundColor = (currentBackgroundColor)=>{
    if (currentBackgroundColor.toLowerCase() === '#ffffff') // getTokenValue doesn't work in SSR thus hardcode fallback to current surface value, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    return (0, $1To4a.default)('elevation.surface', '#1d2125');
    else {
        const lightnessPercentage = (0, $fZitC.getLightnessPercentage)(currentBackgroundColor);
        if (lightnessPercentage === undefined) return currentBackgroundColor;
        return lightnessPercentage > $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX ? (0, $fZitC.reduceLightness)(currentBackgroundColor, $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX) : currentBackgroundColor;
    }
};
const $1b7b278c93e24711$var$applyDarkModeTransformation = (color)=>{
    const hexColor = $1b7b278c93e24711$var$rgbToHex(color); // utility functions require hex colors
    const darkHex = $1b7b278c93e24711$var$getDarkModeBackgroundColor(hexColor);
    return (0, $5kLSq.parseUserColor)(darkHex);
};
const $1b7b278c93e24711$var$areColorsEqual = (color1, color2)=>{
    if (!color1 || !color2) return color1 === color2;
    return color1.r === color2.r && color1.g === color2.g && color1.b === color2.b;
};
const $1b7b278c93e24711$var$rgbToHex = (rgb)=>{
    const toHex = (n)=>{
        const hex = Math.round(n).toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    };
    return `#${toHex(rgb.r)}${toHex(rgb.g)}${toHex(rgb.b)}`.toUpperCase();
};
const $1b7b278c93e24711$var$getCSSVariableValue = (variableExpression)=>{
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};
module.exports["getCustomTheme"] = $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e;

});

parcelRegister("5kLSq", function(module, exports) {

var $9h83k = parcelRequire("9h83k");


var $2qqUS = parcelRequire("2qqUS");


var $75j7G = parcelRequire("75j7G");

function $43edff7874ae2c8f$export$1d30bac67697545c(color) {
    if (color.startsWith('#')) return (0, $9h83k.parseHex)(color);
    if (color.startsWith('rgb(')) return (0, $75j7G.parseRgb)(color);
    if (color.startsWith('hsl(')) return (0, $2qqUS.parseHsl)(color);
    return null;
}
module.exports["parseUserColor"] = $43edff7874ae2c8f$export$1d30bac67697545c;

});

parcelRegister("2qqUS", function(module, exports) {
const $54e8ca9214c53ec0$var$rgbOffset = {
    red: 0,
    green: 120,
    blue: 240
};
/**
 * Returns the contribution of the given RGB channel to the provided hue.
 *
 * Maximum value is 1, meaning it's the main channel for the hue
 * Minimum value is -1, meaning it doesn't contribute to the hue at all
 *
 * The function looks like a single trapezoidal wave that is
 * horizontally shifted according to the hue offset of the given channel.
 */ const $54e8ca9214c53ec0$var$getChannelContributionToHue = ({ rgbChannel: rgbChannel, hue: hue })=>{
    const k = (360 - $54e8ca9214c53ec0$var$rgbOffset[rgbChannel] + hue) / 30 % 12;
    return Math.max(-1, Math.min(k - 3, 9 - k, 1));
};
/**
 * Derived from Wikipedia article on HSL:
 * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
 *
 * You can think of it as taking an RGB channel, and the saturation and lightness values
 * to construct a function mapping hue to channel intensity.
 *
 * It then evaluates the function for the given hue.
 */ const $54e8ca9214c53ec0$var$getRgbChannel = ({ rgbChannel: rgbChannel, color: { h: hue, s: saturation, l: lightness } })=>{
    const shiftY = lightness;
    const scaleY = -1 * saturation * Math.min(lightness, 1 - lightness);
    /**
	 * Value between 0-1 describing how much the RGB channel contributes to the given HSL color.
	 *
	 * `getChannelContributionToHue` is the channel contribution for the pure hue,
	 * which is why we need to adjust and scale according to saturation and lightness.
	 */ const channelContribution = shiftY + scaleY * $54e8ca9214c53ec0$var$getChannelContributionToHue({
        rgbChannel: rgbChannel,
        hue: hue
    });
    return Math.round(255 * channelContribution);
};
function $54e8ca9214c53ec0$export$cbd2e6c3c3c00218(color) {
    /**
	 * I was creating increasingly complex regular expressions, aiming for correct parsing.
	 *
	 * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
	 * with some slight improvements.
	 *
	 * We can refine it as needed.
	 *
	 * Known limitations of this approach:
	 *
	 * - It is overly permissive and will allow some invalid syntax,
	 *   for example `hsl(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
	 * - Only the integer parts of non-integers will be parsed
	 * - Only supports the legacy, comma-separated syntax
	 */ const [h, s, l] = color.replace(/hsl\(|[)%\s]/g, '').split(',').map((value)=>parseInt(value, 10));
    if ([
        h,
        s,
        l
    ].some((channel)=>!Number.isInteger(channel))) return null;
    /**
	 * Normalized HSL value so that:
	 *
	 * - hue angle is from 0 (inclusive) to 360 (not inclusive)
	 * - saturation and lightness percentages are expressed as fractional values from 0 to 1
	 */ const normal = {
        h: h % 360,
        s: Math.min(s / 100, 1),
        l: Math.min(l / 100, 1)
    };
    return {
        r: $54e8ca9214c53ec0$var$getRgbChannel({
            rgbChannel: 'red',
            color: normal
        }),
        g: $54e8ca9214c53ec0$var$getRgbChannel({
            rgbChannel: 'green',
            color: normal
        }),
        b: $54e8ca9214c53ec0$var$getRgbChannel({
            rgbChannel: 'blue',
            color: normal
        })
    };
}
module.exports["parseHsl"] = $54e8ca9214c53ec0$export$cbd2e6c3c3c00218;

});

parcelRegister("75j7G", function(module, exports) {
function $f38224ba77318aee$export$3f3b9febf881d58b(color) {
    /**
	 * I was creating increasingly complex regular expressions, aiming for correct parsing.
	 *
	 * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
	 * with some slight improvements.
	 *
	 * We can refine it as needed.
	 *
	 * Known limitations of this approach:
	 *
	 * - It is overly permissive and will allow some invalid syntax,
	 *   for example `rgb(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
	 * - Only the integer parts of non-integers will be parsed
	 * - Only supports the legacy, comma-separated syntax
	 */ const [r, g, b] = color.replace(/rgb\(|[)\s]/g, '').split(',').map((value)=>parseInt(value, 10))// Clamping to align with CSS behavior
    .map((value)=>Math.max(0, Math.min(value, 255)));
    if ([
        r,
        g,
        b
    ].some((n)=>!Number.isInteger(n))) return null;
    return {
        r: r,
        g: g,
        b: b
    };
}
module.exports["parseRgb"] = $f38224ba77318aee$export$3f3b9febf881d58b;

});


//# sourceMappingURL=PageLayout.c9e5dc12.js.map
